
// import React, { useState } from 'react';
// import '../css/ContactPage.css';
// import Header from "../Common/Header";
// import Footer from '../Common/Footer';

// const ContactPage = () => {


//   const [formData, setFormData] = useState({
//     firstName: '',
//     lastName: '',
//     email: '',
//     subject: '',
//     message: ''
//   });

//     const handleChange = (e) => {
//       setFormData({
//         ...formData, [e.target.name]: e.target.value
//       });
//     };

//     const handleSubmit = (e) => {
//       e.preventDefault();
//       alert('Message sent successfully!');
//   };

//   return (

//     <div className="contact-page">
//        <Header/>
//       <div className="contact-hero">

//         <h1>Contact Us</h1>
//         <p>Have a question or just want to say hi? We’d love to hear from you.</p>
//       </div>

//       <div className="contact-info-section">
//         <div className="info-card email">
//           <h4>Email Us</h4>
//           <p>support@example.com</p>
//         </div>
//         <div className="info-card phone">
//           <h4>Call Us</h4>
//           <p>+91 98765 43210</p>
//         </div>
//         <div className="info-card location">
//           <h4>Visit Us</h4>
//           <p>123 Rainbow Street, India</p>
//         </div>
//       </div>

//       <div className="contact-form-section">
//         <h2>Get In Touch</h2>
//         <p className="form-subtitle">We’ll get back to you within 24 hours.</p>
//         <form onSubmit={handleSubmit} className="contact-form">
//           <div className="form-grid">
//             <div className="input-group">
//               <input type="text" name="firstName" required onChange={handleChange} />
//               <label>First Name</label>
//             </div>
//             <div className="input-group">
//               <input type="text" name="lastName" required onChange={handleChange} />
//               <label>Last Name</label>
//             </div>
//           </div>
//           <div className="input-group">
//             <input type="email" name="email" required onChange={handleChange} />
//             <label>Email Address</label>
//           </div>
//           <div className="input-group">
//             <input type="text" name="subject" required onChange={handleChange} />
//             <label>Subject</label>
//           </div>
//           <div className="input-group">
//             <textarea name="message" rows="6" required onChange={handleChange}></textarea>
//             <label>Your Message</label>
//           </div>
//           <button type="submit">
//             <span>Send Message</span>
//           </button>
//         </form>
//       </div>

//       <div className="map-section">
//         <h2>Our Location</h2>
//         <iframe
//           title="Google Map"
//           src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d14005.340254434928!2d77.2090215!3d28.6139391!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390ce373b9d6af09%3A0x661b2c3a8eac7c!2sConnaught%20Place%2C%20New%20Delhi%2C%20Delhi%20110001%2C%20India!5e0!3m2!1sen!2sin!4v1611123242314!5m2!1sen!2sin"
//           width="100%"
//           height="350"
//           allowFullScreen=""
//           loading="lazy"
//         ></iframe>
//         <Footer/>
//       </div>
//     </div>

//   );
// };


// export default ContactPage;
import React, { useEffect } from 'react';
import Header from "../Common/Header";
import Footer from "../Common/Footer";

const Contact = () => {
  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://assets.calendly.com/assets/external/widget.js";
    script.async = true;
    document.head.appendChild(script);
  }, []);

  return (
    <div>
      <Header />


     
      <div className="container">
        <section className="hero-section">
          <h2>Contact Us</h2>
          {/* Calendly booking form */}

          <div className="calendly-inline-widget" data-url="https://calendly.com/sesslink?hide_landing_page_details=1&hide_gdpr_banner=1" style={{ minWidth: 320, height: 700 }}></div>
          <script type="text/javascript" src="https://assets.calendly.com/assets/external/widget.js" async></script>

        </section>

      </div>
      <Footer />

    </div>
  );
};

export default Contact;
